import { Component, OnInit, Inject, ViewEncapsulation, OnDestroy, AfterViewInit, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Subject } from 'rxjs';
import { OrderDetail } from '../../order.model';
import { PaymentService } from '../payment.services';
import { environment } from 'environments/environment';
import { MyNetServiceType, ServiceDirection } from 'app/_enums/ServiceDirection.enum';
import { FormGroup } from '@angular/forms';
import { Countries } from 'app/main/quotes/international/international.model';

declare var Checkout: any;

@Component({
    selector: 'confirm-checkout',
    templateUrl: './confirm-checkout.component.html',
    styleUrls: ['./confirm-checkout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmCheckoutComponent implements OnInit, OnDestroy {
    order: OrderDetail;
    paymentSessionId: string;
    uniqueId: string;
    loadCheckout: Promise<any>;
    payClicked = false;
    checkoutLoaded = false;
    retryAllowed = false;
    serviceTypeId: MyNetServiceType;
    domesticCountryId = 158; //Lebanon

    protected _unsubscribeAll = new Subject<void>();

    constructor(
        public matDialogRef: MatDialogRef<ConfirmCheckoutComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _paymentService: PaymentService,
        private _snackBar: MatSnackBar
    ) {
        this.order = _data.order;
        this.loadCheckout = new Promise(resolve => {
            this.loadScript();
            resolve(true);
        });
    }

    loadScript(): void {
        let isFound = false;
        const scripts = document.getElementsByTagName('script');
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < scripts.length; ++i) {
            if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes('checkout.js')) {
                isFound = true;
            }
        }
        if (!isFound) {
            const node = document.createElement('script');
            node.src = 'https://ap-gateway.mastercard.com/checkout/version/51/checkout.js';
            node.type = 'text/javascript';
            node.async = false;
           
            node.setAttribute('data-cancel', 'cancelCallback');
            node.setAttribute('data-error', 'errorCallback');
            
            node.setAttribute('data-complete'    , window.location.origin + '/orders/payments/redirect');
            // node.setAttribute('data-complete', window.location.origin + '/orders');

            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }

    ngOnInit(): void {
        this.setServiceTypeId();
        this.loadCheckout.then(_ => {
            this.getCheckoutSession();
        });
        this.domesticCountryId =  parseInt(localStorage.getItem('countryId').toString());
    }

    getCheckoutSession(): void {
        this.retryAllowed = false;
        this._paymentService.createCheckoutSession(this.order.orderId).subscribe(
            result => {
                this.paymentSessionId = result.sessionId;
                this.uniqueId = result.uniqueId;

                if (this.paymentSessionId == null || this.uniqueId === '00000000-0000-0000-0000-000000000000') {
                    this._snackBar.open('Error occured while generating payment session!');
                    this.retryAllowed = true;
                }

                const mainLoopId = setInterval(() => {
                    if (!this.checkoutLoaded) {
                        this.configureCheckoutJs();
                        this.checkoutLoaded = true;
                        clearInterval(mainLoopId);
                    }
                }, 1000);
            },
            error => {
                this._snackBar.open('Error occured while generating payment session!');
                this.retryAllowed = true;
            }
        );
    }

    configureCheckoutJs(): void {
        Checkout.configure({
            merchant: environment.merchantId,
            order: {
                amount: this.order.quote.quotePrice,
                currency: 'USD',
                description: 'New Shipment Order',
                id: this.uniqueId
            },
            session: {
                id: this.paymentSessionId
            },
            interaction: {
                merchant: {
                    name: 'The Net Holding',
                    address: {
                        line1: 'Karantina Seaside Road, Beirut, Lebanon',
                        line2: 'Beirut, Lebanon'
                    },
                    email: 'info@thenet.group',
                    phone: '+961 (1) 593-400',
                    logo: 'https://www.thenet.group/images/logo.svg'
                }
            }
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    confirm(): void {
        this.payClicked = true;
        localStorage.setItem('orderId', this.order.orderId.toString());
        Checkout.showPaymentPage();
    }

    setServiceTypeId(): void {
        switch (this.getDirection()) {
            case ServiceDirection.Domestic:
                this.serviceTypeId = MyNetServiceType.Domestic;
                break;
            case ServiceDirection.Import:
                this.serviceTypeId = MyNetServiceType.Import;
                break;
            case ServiceDirection.Export:
                this.serviceTypeId = MyNetServiceType.Export;
                break;
            default:
                break;
        }
    }

    private getDirection(): ServiceDirection {
        const fromCountryId = this.order.quote.fromCountryId;
        const toCountryId = this.order.quote.toCountryId;

        if (!fromCountryId || !toCountryId) {
            return undefined;
        }

        if (fromCountryId === this.domesticCountryId && toCountryId === this.domesticCountryId) {
            // domestic
            return ServiceDirection.Domestic;
        } else if (fromCountryId === this.domesticCountryId) {
            // Export
            return ServiceDirection.Export;
        } else if (toCountryId === this.domesticCountryId) {
            // Import
            return ServiceDirection.Import;
        } else {
            // Not Supported
            return undefined;
        }
    }

    @HostListener('document:payment-error', ['$event'])
    paymentError(event): void {
    }

    @HostListener('document:payment-canceled', ['$event'])
    paymentCanceled(event): void {
    }
}
